export default "__VITE_ASSET__D0Q5YpEu__"